import React, { useState, useEffect } from 'react';
import { Megaphone, Bell } from 'lucide-react';
import axios from 'axios';
import { getAuthHeaders } from '../../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

function timeAgo(isoStr) {
  if (!isoStr) return '';
  const diff = (Date.now() - new Date(isoStr)) / 1000;
  if (diff < 60) return 'Just now';
  if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.round(diff / 86400)}d ago`;
  return new Date(isoStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}

export default function StudentAnnouncements() {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/student/announcements`, { headers: getAuthHeaders() })
      .then(r => setAnnouncements(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 animate-fade-in-up">
      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-[#F59E0B] font-body mb-1">Updates</p>
        <h1 className="font-heading text-2xl sm:text-3xl font-medium text-[#292524]">Announcements</h1>
        <p className="text-[#57534E] text-sm font-body mt-1">Latest news and updates from Meena.</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-12"><div className="w-10 h-10 border-4 border-[#F59E0B] border-t-transparent rounded-full animate-spin" /></div>
      ) : announcements.length === 0 ? (
        <div className="bg-white rounded-3xl p-10 text-center shadow-card border border-[#E7E5E4]/50">
          <div className="w-14 h-14 bg-[#FFEDD5] rounded-full flex items-center justify-center mx-auto mb-4">
            <Bell className="w-7 h-7 text-[#F59E0B]" strokeWidth={1.5} />
          </div>
          <p className="font-heading text-lg font-medium text-[#292524]">No announcements yet</p>
          <p className="text-[#78716C] text-sm font-body mt-1 max-w-xs mx-auto">
            Check back soon! Meena will post class updates and important notices here.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {announcements.map((ann, i) => (
            <div key={ann.id || i} data-testid={`student-ann-card-${i}`}
              className="bg-white rounded-3xl p-5 shadow-card border border-[#E7E5E4]/50 hover:shadow-card-hover transition-all">
              <div className="flex items-start gap-3">
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center shrink-0 mt-0.5 ${i === 0 ? 'bg-[#F59E0B]' : 'bg-[#FFEDD5]'}`}>
                  <Megaphone className={`w-4 h-4 ${i === 0 ? 'text-white' : 'text-[#F59E0B]'}`} strokeWidth={1.5} />
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between gap-2 flex-wrap">
                    <p className="font-heading font-semibold text-[#292524] text-sm">{ann.title}</p>
                    <p className="text-xs text-[#A8A29E] font-body shrink-0">{timeAgo(ann.created_at)}</p>
                  </div>
                  <p className="text-sm text-[#57534E] font-body leading-relaxed mt-1.5">{ann.message}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
